import React from 'react'
import '../Components/Tabs/Website.css'

const About = () => {
  return (
    <div>
      <h1 className='title'>About Me</h1>
      <div style={{width: '85%', margin: 'auto'}}>
        <div className='container'>
            <div className='section'>
              <h1 className='subheading'>Thomas Dawson</h1>
              <hr />
              <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}>
                <div className='flex-item'>
                    <img src="./Imgs/Professional.jpg" style={{width: '300px'}} className='tracker-img' alt="TrackerImage" />
                </div>
                <div className='flex-item'>
                    <h1 className='heading-proj'>Bio</h1>
                    <p className='tab-p'>I’m a software developer who grew up around and is living in Fargo, North Dakota. 
                    I’ve always been drawn towards using computers and learning as much as I could about how to use them. When I was in high school, 
                    I really wanted to make my own video games, so, using online resources, I learned to code in Java and C#. 
                    From there, I learned how to use the Unity Engine and while still in high school, I made my first game! Since then, I’ve learned that I love coding of any kind. I think it’s fun! </p> 
                </div>
                <div className='flex-item'>
                    <h1 className='heading-proj'>Aspirations</h1>
                    <p className='tab-p'>In the future, I hope to be able to develop software that will help make people’s lives better, whether that be through entertainment or usefulness. 
                    I love solving difficult problems with new innovative solutions. I love programming and being able to leverage that skill to solve those difficult problems. 
                     </p> 
                </div>
              </div>
            <hr />
            <h1 className='subheading'>Contact Info</h1>
            <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}>
                <div className='flex-item'>
                  <h2 className='contact-item'>thomasdawsondev@gmail.com</h2>
                </div>
                <div className='flex-item'>
                    <h2 className='contact-item'>(701) 630-0703</h2>
                </div>
                <div className='flex-item'>
                    <h2 className='contact-item'>Fargo, ND</h2>
                </div>
              </div>
              <hr />
              <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}>
                <div className='flex-item'>
                  <h1 h1 className='heading-proj'>Hobbies</h1>
                  <ul className='list'>
                    <li>Playing Guitar</li>
                    <li>3D modeling/3D printing</li>
                    <li>Wood working</li>
                    <li>Dungeons and Dragons</li>
                  </ul>
                </div>
                <div className='flex-item'>
                  <h1 className='heading-proj'></h1>
                  <p className='tab-p' style={{fontSize: '25px'}}>Feel free to download any one of my games! I love hearing feedback!</p>
                </div>
                <div className='flex-item'>
                    <img src="./Imgs/Sick1.gif" style={{width: '450px'}} className='tracker-img' alt="TrackerImage" />
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default About